import pageTypeResolveService from "../services/PageTypeResolveService";
import newsletterSubscribeFormService from "./NewsletterSubscribeFormService";
import footerContainerToggleService from "./FooterContainerToggleService";

export default new class EshopFooterService {
    public init(): void {
        if (pageTypeResolveService.isBasketPage()) {
            return;
        }

        newsletterSubscribeFormService.init();
        footerContainerToggleService.init();
    }
}();
